import { useAppContext } from '../../context/AppContext';
import { createAdmin } from '../../services';
import { useState } from 'react';

export const SignUpForm = ({ onSuccess, onError }) => {
  const { base_url, setToken } = useAppContext();
  const [formData, setFormData] = useState({
    fname: '',
    lname: '',
    email: '',
    password: '',
    company: ''
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.email || !emailRegex.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
    }
    if (!formData.password || formData.password.length < 6) {
      newErrors.password = 'Password must be at least 6 characters';
    }
    if (!formData.fname.trim()) newErrors.fname = 'First name is required';
    if (!formData.lname.trim()) newErrors.lname = 'Last name is required';
    if (!formData.company.trim()) newErrors.company = 'Company name is required';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      await createAdmin(formData, setToken, base_url);
      onSuccess();
    } catch (error) {
      onError(error.message);
    }
  };

  return (
    <div>
      <div className="step-header">
        <h2>Create Your Account</h2>
        <p>Set up your Slipstream company account to get started.</p>
      </div>

      <form onSubmit={handleSubmit} className="form-section">
        <div className="form-row">
          <div className="form-group">
            <label className="form-label" htmlFor="fname">First name</label>
            <input
              type="text"
              id="fname"
              name="fname"
              className={`form-input${errors.fname ? ' form-input--error' : ''}`}
              value={formData.fname}
              onChange={handleChange}
              required
            />
            {errors.fname && <span className="form-error">{errors.fname}</span>}
          </div>
          <div className="form-group">
            <label className="form-label" htmlFor="lname">Last name</label>
            <input
              type="text"
              id="lname"
              name="lname"
              className={`form-input${errors.lname ? ' form-input--error' : ''}`}
              value={formData.lname}
              onChange={handleChange}
              required
            />
            {errors.lname && <span className="form-error">{errors.lname}</span>}
          </div>
        </div>

        <div className="form-group">
          <label className="form-label" htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            className={`form-input${errors.email ? ' form-input--error' : ''}`}
            value={formData.email}
            onChange={handleChange}
            required
          />
          {errors.email && <span className="form-error">{errors.email}</span>}
        </div>

        <div className="form-group">
          <label className="form-label" htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            name="password"
            className={`form-input${errors.password ? ' form-input--error' : ''}`}
            value={formData.password}
            onChange={handleChange}
            required
          />
          {errors.password && <span className="form-error">{errors.password}</span>}
        </div>

        <div className="form-group">
          <label className="form-label" htmlFor="company">Company name</label>
          <input
            type="text"
            id="company"
            name="company"
            className={`form-input${errors.company ? ' form-input--error' : ''}`}
            value={formData.company}
            onChange={handleChange}
            required
          />
          {errors.company && <span className="form-error">{errors.company}</span>}
        </div>

        <div className="step-nav step-nav--no-top-rule">
          <div />
          <button type="submit" className="btn btn-primary">
            Create Account
          </button>
        </div>
      </form>
    </div>
  );
};
